import apiClient from './client';

export interface Chiusura {
  data: string;
  impianto_chiuso: boolean;
  ricezione_chiusa: boolean;
  lavorazione_chiusa: boolean;
  note: string | null;
  updated_by_name: string | null;
  updated_at: string | null;
}

export interface ChiusureResponse {
  chiusure: Chiusura[];
}

export async function getChiusure(from: string, to: string): Promise<ChiusureResponse> {
  const res = await apiClient.get('/api/calendario-chiusure', { params: { from, to } });
  return res.data;
}

export async function upsertChiusura(data: string, body: {
  impianto_chiuso: boolean;
  ricezione_chiusa: boolean;
  lavorazione_chiusa: boolean;
  note?: string | null;
}): Promise<Chiusura | { deleted: boolean; data: string }> {
  const res = await apiClient.put(`/api/calendario-chiusure/${data}`, body);
  return res.data;
}

export async function deleteChiusura(data: string): Promise<void> {
  await apiClient.delete(`/api/calendario-chiusure/${data}`);
}
